import { render, staticRenderFns } from "./CatalogCards.vue?vue&type=template&id=99cd3d1c&scoped=true&"
import script from "./CatalogCards.vue?vue&type=script&lang=js&"
export * from "./CatalogCards.vue?vue&type=script&lang=js&"
import style0 from "./CatalogCards.vue?vue&type=style&index=0&id=99cd3d1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cd3d1c",
  null
  
)

export default component.exports